import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import MarketingDetails from "./MarketingDetails";

const MarketingSinglePage: React.FC = () => {
     useEffect(() => {
                            document.title = "AI Marketing| Brain Machine AI";
                          }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="AI Marketing" pagesub="AI Marketing" />
                        <MarketingDetails/>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default MarketingSinglePage;
